module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.loading) ? _c('div', {
    staticClass: "row my-4"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('vue-content-loading', {
    attrs: {
      "secondary": "#ffc107"
    }
  }, [_c('rect', {
    attrs: {
      "x": "0",
      "y": "0",
      "rx": "5",
      "ry": "5",
      "width": "100%",
      "height": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "15",
      "rx": "5",
      "ry": "5",
      "width": "100%",
      "height": "10"
    }
  }), _vm._v(" "), _c('rect', {
    attrs: {
      "x": "0",
      "y": "30",
      "rx": "5",
      "ry": "5",
      "width": "100%",
      "height": "10"
    }
  })])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-713958de"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/PartialLoader.vue
// module id = 1327
// module chunks = 1